import { GET_PENDING_OUTLETS, SET_PENDING_OUTLETS_LOADING, SET_PENDING_OUTLETS_ERROR } from '../types/PendingOutlets';

const initialState = {
    pendingOutlets: [],
    loading: false,
    error: null,
    message: null,
    lastFetchedRestaurantId: null, // Track which restaurant we last fetched for
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_PENDING_OUTLETS:
            return {
                ...state,
                pendingOutlets: action.payload.data || [],
                message: action.payload.message || null,
                loading: false,
                error: null,
                lastFetchedRestaurantId: action.payload.restaurantId, // Store the restaurant ID
            };
        case SET_PENDING_OUTLETS_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case SET_PENDING_OUTLETS_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};
